import dayjs from 'dayjs';
import { DateFormats } from '@/constants/dates';

export const formatDate = (date: string, format: DateFormats = DateFormats.DEFAULT) => dayjs(date).format(format);

export const formatDateForApiRequest = (date: string, currentFormat: DateFormats) =>
  !!date ? dayjs(date, currentFormat).format(DateFormats.DATE_YEAR_MONTH_DAY) : null;
